import { CalculationTypeCodes, ChargingPeriodTypeCodes, PriceListTypeCodes, UnitOfMeasurementCodes } from '@common/classes/codes';
import { AbstractDueItemListComponent } from '@common/classes/due-item-list';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/forms";
import * as i3 from "@ngx-translate/core";
import * as i4 from "@progress/kendo-angular-grid";
import * as i5 from "../../../common/components/app-control/app-control.component";
import * as i6 from "../../../common/components/editable-grid/editable-grid.component";
import * as i7 from "../cargo-class-list/cargo-class-list.component";
import * as i8 from "../../../common/pipes/codelist.pipe";
function DueItemListComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 13);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_3_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r12);
      const dataItem_r10 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r10.name = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r10 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r10.name)("entity", dataItem_r10);
  }
}
function DueItemListComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 14);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_6_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r15);
      const dataItem_r13 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r13.invoiceDescription = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r13 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r13.invoiceDescription)("entity", dataItem_r13);
  }
}
function DueItemListComponent_kendo_grid_column_7_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 16);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_kendo_grid_column_7_ng_template_2_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r20);
      const dataItem_r18 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r18.unitOfMeasurementId = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r18 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r18.unitOfMeasurementId)("entity", dataItem_r18);
  }
}
function DueItemListComponent_kendo_grid_column_7_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const dataItem_r21 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, dataItem_r21.unitOfMeasurementId, "UnitOfMeasurement")), " ");
  }
}
function DueItemListComponent_kendo_grid_column_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-grid-column", 15);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, DueItemListComponent_kendo_grid_column_7_ng_template_2_Template, 1, 2, "ng-template", 2);
    i0.ɵɵtemplate(3, DueItemListComponent_kendo_grid_column_7_ng_template_3_Template, 3, 6, "ng-template", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 1, "Unit Of Measurement"));
  }
}
function DueItemListComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 17);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_10_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r24);
      const dataItem_r22 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r22.validFrom = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r22 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r22.validFrom)("entity", dataItem_r22);
  }
}
function DueItemListComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 18);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_13_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r27);
      const dataItem_r25 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r25.validTo = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r25 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r25.validTo)("entity", dataItem_r25);
  }
}
function DueItemListComponent_kendo_grid_column_14_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 20);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_kendo_grid_column_14_ng_template_2_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r32);
      const dataItem_r30 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r30.rate = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r30 = ctx.dataItem;
    i0.ɵɵproperty("min", 0)("ngModel", dataItem_r30.rate)("entity", dataItem_r30);
  }
}
function DueItemListComponent_kendo_grid_column_14_ng_template_3_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r34.currency);
  }
}
function DueItemListComponent_kendo_grid_column_14_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "number");
    i0.ɵɵtemplate(2, DueItemListComponent_kendo_grid_column_14_ng_template_3_span_2_Template, 2, 1, "span", 21);
  }
  if (rf & 2) {
    const dataItem_r33 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(1, 2, dataItem_r33.rate, "1.2-4"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", dataItem_r33.rate);
  }
}
function DueItemListComponent_kendo_grid_column_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-grid-column", 19);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, DueItemListComponent_kendo_grid_column_14_ng_template_2_Template, 1, 3, "ng-template", 2);
    i0.ɵɵtemplate(3, DueItemListComponent_kendo_grid_column_14_ng_template_3_Template, 3, 5, "ng-template", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 1, "Rate"));
  }
}
function DueItemListComponent_kendo_grid_column_15_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 23);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_kendo_grid_column_15_ng_template_2_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r38);
      const dataItem_r36 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r36.chargingPeriod = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r36 = ctx.dataItem;
    i0.ɵɵproperty("min", 1)("max", 365)("ngModel", dataItem_r36.chargingPeriod)("entity", dataItem_r36);
  }
}
function DueItemListComponent_kendo_grid_column_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-grid-column", 22);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, DueItemListComponent_kendo_grid_column_15_ng_template_2_Template, 1, 4, "ng-template", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 1, "Charging Period"));
  }
}
function DueItemListComponent_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const dataItem_r39 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, dataItem_r39.chargingPeriodTypeId, "ChargingPeriodType")), " ");
  }
}
function DueItemListComponent_kendo_grid_column_19_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 25);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_kendo_grid_column_19_ng_template_2_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r44);
      const dataItem_r42 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r42.calculationTypeId = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r42 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r42.calculationTypeId)("entity", dataItem_r42);
  }
}
function DueItemListComponent_kendo_grid_column_19_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const dataItem_r45 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, dataItem_r45.calculationTypeId, "CalculationType")), " ");
  }
}
function DueItemListComponent_kendo_grid_column_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-grid-column", 24);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, DueItemListComponent_kendo_grid_column_19_ng_template_2_Template, 1, 2, "ng-template", 2);
    i0.ɵɵtemplate(3, DueItemListComponent_kendo_grid_column_19_ng_template_3_Template, 3, 6, "ng-template", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 1, "Calculation"));
  }
}
function DueItemListComponent_ng_template_20_div_0_app_control_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r72 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 46);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_20_div_0_app_control_2_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r72);
      const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
      return i0.ɵɵresetView(dataItem_r46.maxFee = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 4, "Max Fee"))("min", 0)("ngModel", dataItem_r46.maxFee)("entity", dataItem_r46);
  }
}
function DueItemListComponent_ng_template_20_div_0_app_control_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r76 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 47);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_20_div_0_app_control_3_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r76);
      const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
      return i0.ɵɵresetView(dataItem_r46.permitStatusId = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "Permit Status"))("ngModel", dataItem_r46.permitStatusId)("entity", dataItem_r46);
  }
}
function DueItemListComponent_ng_template_20_div_0_app_control_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r80 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 48);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_20_div_0_app_control_4_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r80);
      const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
      return i0.ɵɵresetView(dataItem_r46.berthId = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "Berth"))("ngModel", dataItem_r46.berthId)("entity", dataItem_r46);
  }
}
function DueItemListComponent_ng_template_20_div_0_app_control_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r84 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 49);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_20_div_0_app_control_5_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r84);
      const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
      return i0.ɵɵresetView(dataItem_r46.localPortOfLoadingId = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "Local Ports Of Loading"))("ngModel", dataItem_r46.localPortOfLoadingId)("entity", dataItem_r46);
  }
}
function DueItemListComponent_ng_template_20_div_0_app_control_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r88 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 50);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_20_div_0_app_control_6_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r88);
      const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
      return i0.ɵɵresetView(dataItem_r46.periodsToChargeNormalRate = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 4, "Periods To Charge Normal Rate"))("min", 1)("ngModel", dataItem_r46.periodsToChargeNormalRate)("entity", dataItem_r46);
  }
}
function DueItemListComponent_ng_template_20_div_0_app_control_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r92 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 51);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_20_div_0_app_control_8_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
      return i0.ɵɵresetView(dataItem_r46.vesselsAlongside = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 4, "Vessels Alongside"))("min", 1)("ngModel", dataItem_r46.vesselsAlongside)("entity", dataItem_r46);
  }
}
function DueItemListComponent_ng_template_20_div_0_app_control_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r96 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 52);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_20_div_0_app_control_9_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r96);
      const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
      return i0.ɵɵresetView(dataItem_r46.localPortOfDischargeId = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "Local Ports Of Discharge"))("ngModel", dataItem_r46.localPortOfDischargeId)("entity", dataItem_r46);
  }
}
function DueItemListComponent_ng_template_20_div_0_app_control_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r100 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 53);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_20_div_0_app_control_10_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r100);
      const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
      return i0.ɵɵresetView(dataItem_r46.percentChargeThereafter = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r46 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "Percent Charge Thereafter"))("ngModel", dataItem_r46.percentChargeThereafter)("entity", dataItem_r46);
  }
}
function DueItemListComponent_ng_template_20_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36)(1, "div", 37);
    i0.ɵɵtemplate(2, DueItemListComponent_ng_template_20_div_0_app_control_2_Template, 2, 6, "app-control", 38);
    i0.ɵɵtemplate(3, DueItemListComponent_ng_template_20_div_0_app_control_3_Template, 2, 5, "app-control", 39);
    i0.ɵɵtemplate(4, DueItemListComponent_ng_template_20_div_0_app_control_4_Template, 2, 5, "app-control", 40);
    i0.ɵɵtemplate(5, DueItemListComponent_ng_template_20_div_0_app_control_5_Template, 2, 5, "app-control", 41);
    i0.ɵɵtemplate(6, DueItemListComponent_ng_template_20_div_0_app_control_6_Template, 2, 6, "app-control", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 37);
    i0.ɵɵtemplate(8, DueItemListComponent_ng_template_20_div_0_app_control_8_Template, 2, 6, "app-control", 43);
    i0.ɵɵtemplate(9, DueItemListComponent_ng_template_20_div_0_app_control_9_Template, 2, 5, "app-control", 44);
    i0.ɵɵtemplate(10, DueItemListComponent_ng_template_20_div_0_app_control_10_Template, 2, 5, "app-control", 45);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r47.priceListTypeId === "WMF");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r47.priceListTypeId === "PFE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r47.priceListTypeId === "SFE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r47.priceListTypeId === "DMF");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r47.priceListTypeId === "ADE");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r47.priceListTypeId === "SFE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r47.priceListTypeId === "DMF");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r47.priceListTypeId === "ADE");
  }
}
function DueItemListComponent_ng_template_20_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r105 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 13, 54);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_20_ng_template_4_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r105);
      const dataItem_r102 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r102.name = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r102 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r102.name)("entity", dataItem_r102);
  }
}
function DueItemListComponent_ng_template_20_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const dataItem_r106 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", dataItem_r106.name, " ");
  }
}
function DueItemListComponent_ng_template_20_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r109 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 55);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_20_ng_template_7_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r109);
      const dataItem_r107 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r107.from = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r107 = ctx.dataItem;
    i0.ɵɵproperty("min", 0)("ngModel", dataItem_r107.from)("entity", dataItem_r107);
  }
}
function DueItemListComponent_ng_template_20_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const dataItem_r110 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", dataItem_r110.from, " ");
  }
}
function DueItemListComponent_ng_template_20_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r113 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 56);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_20_ng_template_10_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r113);
      const dataItem_r111 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r111.to = $event);
    })("ngModelChange", function DueItemListComponent_ng_template_20_ng_template_10_Template_app_control_ngModelChange_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r113);
      const dataItem_r111 = restoredCtx.dataItem;
      const ctx_r114 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r114.updateItem(dataItem_r111));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r111 = ctx.dataItem;
    i0.ɵɵproperty("min", 0)("ngModel", dataItem_r111.to)("entity", dataItem_r111);
  }
}
function DueItemListComponent_ng_template_20_ng_template_11_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "\u221E");
    i0.ɵɵelementEnd();
  }
}
function DueItemListComponent_ng_template_20_ng_template_11_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const dataItem_r115 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate(dataItem_r115.to);
  }
}
function DueItemListComponent_ng_template_20_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DueItemListComponent_ng_template_20_ng_template_11_span_0_Template, 2, 0, "span", 57);
    i0.ɵɵtemplate(1, DueItemListComponent_ng_template_20_ng_template_11_ng_template_1_Template, 1, 1, "ng-template", null, 58, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const dataItem_r115 = ctx.$implicit;
    const _r117 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngIf", dataItem_r115.to === 0)("ngIfElse", _r117);
  }
}
function DueItemListComponent_ng_template_20_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r122 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 59);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_20_ng_template_13_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r122);
      const dataItem_r120 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r120.intervalRate = $event);
    })("ngModelChange", function DueItemListComponent_ng_template_20_ng_template_13_Template_app_control_ngModelChange_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r122);
      const dataItem_r120 = restoredCtx.dataItem;
      const ctx_r123 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r123.updateItem(dataItem_r120));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r120 = ctx.dataItem;
    i0.ɵɵproperty("min", 0)("ngModel", dataItem_r120.intervalRate)("entity", dataItem_r120);
  }
}
function DueItemListComponent_ng_template_20_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "number");
  }
  if (rf & 2) {
    const dataItem_r124 = ctx.$implicit;
    const ctx_r55 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(1, 2, dataItem_r124.intervalRate, "1.2-4"), " ", ctx_r55.currency, " ");
  }
}
function DueItemListComponent_ng_template_20_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r127 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 60);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_20_ng_template_17_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r127);
      const dataItem_r125 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r125.multiplier = $event);
    })("ngModelChange", function DueItemListComponent_ng_template_20_ng_template_17_Template_app_control_ngModelChange_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r127);
      const dataItem_r125 = restoredCtx.dataItem;
      const ctx_r128 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r128.updateItem(dataItem_r125));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r125 = ctx.dataItem;
    i0.ɵɵproperty("isDisabled", dataItem_r125.to === 0)("ngModel", dataItem_r125.multiplier)("entity", dataItem_r125);
  }
}
function DueItemListComponent_ng_template_20_ng_template_18_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r129 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(dataItem_r129.multiplier);
  }
}
function DueItemListComponent_ng_template_20_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DueItemListComponent_ng_template_20_ng_template_18_span_0_Template, 2, 1, "span", 21);
  }
  if (rf & 2) {
    const dataItem_r129 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", dataItem_r129.to > 0);
  }
}
function DueItemListComponent_ng_template_20_ng_template_21_Template(rf, ctx) {
  if (rf & 1) {
    const _r134 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 61);
    i0.ɵɵlistener("ngModelChange", function DueItemListComponent_ng_template_20_ng_template_21_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r134);
      const dataItem_r132 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r132.fixedRate = $event);
    })("ngModelChange", function DueItemListComponent_ng_template_20_ng_template_21_Template_app_control_ngModelChange_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r134);
      const dataItem_r132 = restoredCtx.dataItem;
      const ctx_r135 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r135.updateItem(dataItem_r132));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r132 = ctx.dataItem;
    i0.ɵɵproperty("min", 0)("ngModel", dataItem_r132.fixedRate)("entity", dataItem_r132);
  }
}
function DueItemListComponent_ng_template_20_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "number");
  }
  if (rf & 2) {
    const dataItem_r136 = ctx.$implicit;
    const ctx_r59 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(1, 2, dataItem_r136.fixedRate, "1.2-4"), " ", ctx_r59.currency, " ");
  }
}
function DueItemListComponent_ng_template_20_ng_template_25_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r137 = i0.ɵɵnextContext().$implicit;
    const ctx_r138 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind2(2, 2, dataItem_r137.total, "1.2-4"), " ", ctx_r138.currency, "");
  }
}
function DueItemListComponent_ng_template_20_ng_template_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DueItemListComponent_ng_template_20_ng_template_25_span_0_Template, 3, 5, "span", 21);
  }
  if (rf & 2) {
    const dataItem_r137 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", dataItem_r137.to > 0);
  }
}
function DueItemListComponent_ng_template_20_div_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 62)(1, "h5", 63);
    i0.ɵɵtext(2, "Cargo Classes");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "app-cargo-class-list", 64);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r46 = i0.ɵɵnextContext().$implicit;
    const ctx_r61 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("data", dataItem_r46.cargoClasses)("editMode", ctx_r61.editMode);
  }
}
function DueItemListComponent_ng_template_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DueItemListComponent_ng_template_20_div_0_Template, 11, 8, "div", 26);
    i0.ɵɵelementStart(1, "app-editable-grid", 27)(2, "kendo-grid-column", 28);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, DueItemListComponent_ng_template_20_ng_template_4_Template, 2, 2, "ng-template", 2);
    i0.ɵɵtemplate(5, DueItemListComponent_ng_template_20_ng_template_5_Template, 1, 1, "ng-template", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "kendo-grid-column", 29);
    i0.ɵɵtemplate(7, DueItemListComponent_ng_template_20_ng_template_7_Template, 1, 3, "ng-template", 2);
    i0.ɵɵtemplate(8, DueItemListComponent_ng_template_20_ng_template_8_Template, 1, 1, "ng-template", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "kendo-grid-column", 30);
    i0.ɵɵtemplate(10, DueItemListComponent_ng_template_20_ng_template_10_Template, 1, 3, "ng-template", 2);
    i0.ɵɵtemplate(11, DueItemListComponent_ng_template_20_ng_template_11_Template, 3, 2, "ng-template", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "kendo-grid-column", 31);
    i0.ɵɵtemplate(13, DueItemListComponent_ng_template_20_ng_template_13_Template, 1, 3, "ng-template", 2);
    i0.ɵɵtemplate(14, DueItemListComponent_ng_template_20_ng_template_14_Template, 2, 5, "ng-template", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "kendo-grid-column", 32);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵtemplate(17, DueItemListComponent_ng_template_20_ng_template_17_Template, 1, 3, "ng-template", 2);
    i0.ɵɵtemplate(18, DueItemListComponent_ng_template_20_ng_template_18_Template, 1, 1, "ng-template", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "kendo-grid-column", 33);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵtemplate(21, DueItemListComponent_ng_template_20_ng_template_21_Template, 1, 3, "ng-template", 2);
    i0.ɵɵtemplate(22, DueItemListComponent_ng_template_20_ng_template_22_Template, 2, 5, "ng-template", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "kendo-grid-column", 34);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵtemplate(25, DueItemListComponent_ng_template_20_ng_template_25_Template, 1, 1, "ng-template", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(26, DueItemListComponent_ng_template_20_div_26_Template, 4, 2, "div", 35);
  }
  if (rf & 2) {
    const dataItem_r46 = ctx.$implicit;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r9.priceListTypeId !== "TFE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", dataItem_r46.ranges)("editMode", ctx_r9.editMode)("pageable", false)("sort", ctx_r9.gridSort);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(3, 13, "Range Name"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("title", dataItem_r46.unitOfMeasurementId + " From");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", dataItem_r46.unitOfMeasurementId + " To");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", "Rate Per " + dataItem_r46.unitOfMeasurementId + " Interval");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(16, 15, "Multiplier"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(20, 17, "Fixed Rate"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(24, 19, "Total Amount"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r9.priceListTypeId === "TFE");
  }
}
export class DueItemListComponent extends AbstractDueItemListComponent {
  constructor() {
    super(...arguments);
    this.showUomColumn = true;
    this.showRateColumn = false;
  }
  ngOnInit() {
    super.ngOnInit();
    this.showUomColumn = ![PriceListTypeCodes.SecurityFee, PriceListTypeCodes.OverhangingonLascarisWharf, PriceListTypeCodes.PermitFee].includes(this.priceListTypeId);
    this.showRateColumn = [PriceListTypeCodes.SecurityFee, PriceListTypeCodes.OverhangingonLascarisWharf, PriceListTypeCodes.PermitFee, PriceListTypeCodes.EnergyConsumption].includes(this.priceListTypeId);
    switch (this.priceListTypeId) {
      case PriceListTypeCodes.PortDues:
      case PriceListTypeCodes.LaidUpDues:
        return super.setItemCreateParameters(UnitOfMeasurementCodes.NetTonnage, ChargingPeriodTypeCodes.Day, CalculationTypeCodes.Range);
      case PriceListTypeCodes.BerthageDues:
      case PriceListTypeCodes.AnchorageDues:
        return super.setItemCreateParameters(UnitOfMeasurementCodes.LengthOverall, ChargingPeriodTypeCodes.Day, CalculationTypeCodes.Range);
      case PriceListTypeCodes.ThroughputFee:
        return super.setItemCreateParameters(UnitOfMeasurementCodes.GrossTonnage, ChargingPeriodTypeCodes.OneTime, CalculationTypeCodes.Range);
      case PriceListTypeCodes.WasteManagementFee:
        return super.setItemCreateParameters(null, ChargingPeriodTypeCodes.OneTime, CalculationTypeCodes.Range);
      case PriceListTypeCodes.PermitFee:
        return super.setItemCreateParameters(null, ChargingPeriodTypeCodes.OneTime);
      case PriceListTypeCodes.OverhangingonLascarisWharf:
        return super.setItemCreateParameters(null, ChargingPeriodTypeCodes.OneTime);
      case PriceListTypeCodes.EnergyConsumption:
        return super.setItemCreateParameters(null, ChargingPeriodTypeCodes.OneTime, CalculationTypeCodes.Fixed);
      default:
        return super.setItemCreateParameters();
    }
  }
  showDetailRow(dataItem) {
    return dataItem.calculationTypeId === 'RNG';
  }
  updateItem(item) {
    item.total = item.to > 0 ? item.intervalRate * item.multiplier + item.fixedRate : 0;
  }
}
DueItemListComponent.ɵfac = /*@__PURE__*/function () {
  let ɵDueItemListComponent_BaseFactory;
  return function DueItemListComponent_Factory(t) {
    return (ɵDueItemListComponent_BaseFactory || (ɵDueItemListComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DueItemListComponent)))(t || DueItemListComponent);
  };
}();
DueItemListComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: DueItemListComponent,
  selectors: [["app-due-item-list"]],
  inputs: {
    priceListTypeId: "priceListTypeId"
  },
  features: [i0.ɵɵInheritDefinitionFeature],
  decls: 21,
  vars: 24,
  consts: [["entityName", "DueItem", 3, "data", "createParameters", "editMode", "pageable", "rowAction"], ["field", "name", "width", "300", 3, "title"], ["kendoGridEditTemplate", ""], ["field", "invoiceDescription", "width", "300", 3, "title"], ["field", "unitOfMeasurementId", 3, "title", 4, "ngIf"], ["field", "validFrom", "format", "d", 3, "title"], ["field", "validTo", "format", "d", 3, "title"], ["field", "rate", 3, "title", 4, "ngIf"], ["field", "chargingPeriod", 3, "title", 4, "ngIf"], ["field", "chargingPeriodTypeId", 3, "title"], ["kendoGridCellTemplate", ""], ["field", "calculationTypeId", 3, "title", 4, "ngIf"], ["kendoGridDetailTemplate", "", 3, "kendoGridDetailTemplateShowIf"], ["property", "name", 3, "ngModel", "entity", "ngModelChange"], ["property", "invoiceDescription", 3, "ngModel", "entity", "ngModelChange"], ["field", "unitOfMeasurementId", 3, "title"], ["type", "codelist", "codelist", "UnitOfMeasurement", "property", "unitOfMeasurementId", 3, "ngModel", "entity", "ngModelChange"], ["type", "datetime", "property", "validFrom", 3, "ngModel", "entity", "ngModelChange"], ["type", "datetime", "property", "validTo", 3, "ngModel", "entity", "ngModelChange"], ["field", "rate", 3, "title"], ["type", "number", "property", "rate", 3, "min", "ngModel", "entity", "ngModelChange"], [4, "ngIf"], ["field", "chargingPeriod", 3, "title"], ["type", "number", "format", "#", "property", "chargingPeriod", 3, "min", "max", "ngModel", "entity", "ngModelChange"], ["field", "calculationTypeId", 3, "title"], ["type", "codelist", "codelist", "CalculationType", "property", "calculationTypeId", 3, "ngModel", "entity", "ngModelChange"], ["class", "row mb-3", 4, "ngIf"], ["entityName", "DueItemRange", 3, "data", "editMode", "pageable", "sort"], ["field", "name", 3, "title"], ["field", "from", 3, "title"], ["field", "to", 3, "title"], ["field", "intervalRate", 3, "title"], ["field", "multiplier", 3, "title"], ["field", "fixedRate", 3, "title"], ["field", "total", 3, "title"], ["class", "mt-3", 4, "ngIf"], [1, "row", "mb-3"], [1, "col-3"], ["type", "number", "format", "n4", "property", "maxFee", 3, "label", "min", "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", "type", "codelist", "codelist", "PermitStatus", "property", "permitStatusId", 3, "label", "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", "codelist", "Berth", "property", "berthId", 3, "label", "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", "codelist", "LocalPortFilter", "property", "localPortOfLoadingId", 3, "label", "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "number", "format", "n0", "property", "periodsToChargeNormalRate", 3, "label", "min", "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "number", "format", "#", "property", "vesselsAlongside", 3, "label", "min", "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "codelist", "codelist", "LocalPortFilter", "property", "localPortOfDischargeId", 3, "label", "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "number", "format", "n2", "property", "percentChargeThereafter", 3, "label", "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["type", "number", "format", "n4", "property", "maxFee", 3, "label", "min", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "type", "codelist", "codelist", "PermitStatus", "property", "permitStatusId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Berth", "property", "berthId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "LocalPortFilter", "property", "localPortOfLoadingId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "number", "format", "n0", "property", "periodsToChargeNormalRate", 3, "label", "min", "ngModel", "entity", "ngModelChange"], ["type", "number", "format", "#", "property", "vesselsAlongside", 3, "label", "min", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "LocalPortFilter", "property", "localPortOfDischargeId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "number", "format", "n2", "property", "percentChargeThereafter", 3, "label", "ngModel", "entity", "ngModelChange"], ["rangeName", ""], ["type", "number", "format", "#", "property", "from", 3, "min", "ngModel", "entity", "ngModelChange"], ["type", "number", "format", "#", "property", "to", 3, "min", "ngModel", "entity", "ngModelChange"], [4, "ngIf", "ngIfElse"], ["default", ""], ["type", "number", "format", "n4", "property", "intervalRate", 3, "min", "ngModel", "entity", "ngModelChange"], ["type", "number", "format", "#", "property", "multiplier", 3, "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "number", "property", "fixedRate", 3, "min", "ngModel", "entity", "ngModelChange"], [1, "mt-3"], ["translate", ""], [3, "data", "editMode"]],
  template: function DueItemListComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "app-editable-grid", 0);
      i0.ɵɵlistener("rowAction", function DueItemListComponent_Template_app_editable_grid_rowAction_0_listener($event) {
        return ctx.handleRowAction($event);
      });
      i0.ɵɵelementStart(1, "kendo-grid-column", 1);
      i0.ɵɵpipe(2, "translate");
      i0.ɵɵtemplate(3, DueItemListComponent_ng_template_3_Template, 1, 2, "ng-template", 2);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(4, "kendo-grid-column", 3);
      i0.ɵɵpipe(5, "translate");
      i0.ɵɵtemplate(6, DueItemListComponent_ng_template_6_Template, 1, 2, "ng-template", 2);
      i0.ɵɵelementEnd();
      i0.ɵɵtemplate(7, DueItemListComponent_kendo_grid_column_7_Template, 4, 3, "kendo-grid-column", 4);
      i0.ɵɵelementStart(8, "kendo-grid-column", 5);
      i0.ɵɵpipe(9, "translate");
      i0.ɵɵtemplate(10, DueItemListComponent_ng_template_10_Template, 1, 2, "ng-template", 2);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(11, "kendo-grid-column", 6);
      i0.ɵɵpipe(12, "translate");
      i0.ɵɵtemplate(13, DueItemListComponent_ng_template_13_Template, 1, 2, "ng-template", 2);
      i0.ɵɵelementEnd();
      i0.ɵɵtemplate(14, DueItemListComponent_kendo_grid_column_14_Template, 4, 3, "kendo-grid-column", 7);
      i0.ɵɵtemplate(15, DueItemListComponent_kendo_grid_column_15_Template, 3, 3, "kendo-grid-column", 8);
      i0.ɵɵelementStart(16, "kendo-grid-column", 9);
      i0.ɵɵpipe(17, "translate");
      i0.ɵɵtemplate(18, DueItemListComponent_ng_template_18_Template, 3, 6, "ng-template", 10);
      i0.ɵɵelementEnd();
      i0.ɵɵtemplate(19, DueItemListComponent_kendo_grid_column_19_Template, 4, 3, "kendo-grid-column", 11);
      i0.ɵɵtemplate(20, DueItemListComponent_ng_template_20_Template, 27, 21, "ng-template", 12);
      i0.ɵɵelementEnd();
    }
    if (rf & 2) {
      i0.ɵɵproperty("data", ctx.items)("createParameters", ctx.itemCreateParameters)("editMode", ctx.editMode)("pageable", false);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 14, "Item Name"));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(5, 16, "Invoice Description"));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("ngIf", ctx.showUomColumn);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(9, 18, "Valid From"));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(12, 20, "Valid To"));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("ngIf", ctx.showRateColumn);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", (ctx.itemCreateParameters == null ? null : ctx.itemCreateParameters.chargingPeriodTypeId) !== "OTM");
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(17, 22, "Charging Period Type"));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("ngIf", (ctx.itemCreateParameters == null ? null : ctx.itemCreateParameters.calculationTypeId) === "RNG" || ctx.priceListTypeId === "ENC");
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("kendoGridDetailTemplateShowIf", ctx.showDetailRow);
    }
  },
  dependencies: [i1.NgIf, i2.NgControlStatus, i2.NgModel, i3.TranslateDirective, i4.ColumnComponent, i4.DetailTemplateDirective, i4.CellTemplateDirective, i4.EditTemplateDirective, i5.AppControlComponent, i6.EditableGridComponent, i7.CargoClassListComponent, i1.AsyncPipe, i1.DecimalPipe, i3.TranslatePipe, i8.CodelistPipe],
  styles: ["\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZVJvb3QiOiIifQ== */"]
});